import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { AREA_CAPABILITIES } from '../areaCapabilities';
import { CateringHub } from '../lazyComponents';

/** Catering food cost estimation — single hub with ficha tabs (estimator, catalog, rations, estimates). */
export function CateringRoutes({ withCapability }) {
  const hub = withCapability(AREA_CAPABILITIES.catering, <CateringHub />);

  return (
    <>
      <Route path="/catering" element={withCapability(AREA_CAPABILITIES.catering, <Navigate to="/catering/estimator" replace />)} />
      <Route path="/catering/estimator" element={hub} />
      <Route path="/catering/food-items" element={hub} />
      <Route path="/catering/rations" element={hub} />
      <Route path="/catering/estimates" element={hub} />
    </>
  );
}
